export default __webpack_public_path__ + "images/double-arrow.svg";